<template>
  <div class="lg:px-12 md:px-12 px-5 lg:pb-12 md:pb-12 py-8 landing">
    <div class="">
      <p class="fsize32 sm-fsize24 font-semibold text-primary text-center">
        LATEST BLOG HIGHLIGHTS
      </p>

      <swiper
        class="swiper pad-5 mt-6"
        :options="swiperOptions"
        v-if="blogs.length !== 0"
      >
        <swiper-slide v-for="blog in blogs" :key="blog._id">
          <div>
            <div
              class="rounded-b-lg relative shadow-xl bg-white overflow-hidden"
              @click="readFullBlogs(blog)"
            >
              <!-- <span class="" v-if="blog.onlySubscribed">
              For Subscribers Only
            </span>
            <span class="" v-if="blog.onlyRegistered && !blog.onlySubscribed">
              For Registered Users Only
            </span> -->

              <img
                v-if="blog.image"
                :src="`${$imageURL}/${blog.image}`"
                alt="img"
                class="w-full h-44 object-cover"
              />
              <img
                v-else
                src="https://nimbus-server-01.brained.in/nimbus-server-01/default/images/default2.jpg"
                alt="img"
                class="w-full h-44 object-cover"
              />
              <el-tooltip
                class="item"
                effect="dark"
                content=" For Subscribers Only"
                placement="top-start"
              >
                <span
                  class="absolute top-3 left-3 z-index-999 bg-ede3fa py-1 px-3 rounded-full fsize15 text-primary"
                  v-if="blog.onlySubscribed"
                >
                  For {{ blog.memberships[0].name }} Only
                </span>
              </el-tooltip>
              <div class="p-4 bg-white">
                <p
                  class="text-black footertitle font-bold cursor-pointer fsize18-14px ellipsis-1 lh-28"
                >
                  {{ blog.title }}
                </p>
                <p class="pt-2 clr777 font-normal">
                  Date : {{ blog.date.slice(0, 10).replaceAll("-", "/") }}
                </p>
                <p class="ellipsis-2 pt-2 h-16" v-html="blog.html"></p>
              </div>
            </div>
          </div>
        </swiper-slide>

        <div class="swiper-button-prev adminswiper" slot="button-prev"></div>
        <div class="swiper-button-next adminswiper" slot="button-next"></div>
      </swiper>
    </div>
  </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import blogMixin from "../../insights/blogs/mixins/blogMixin";
import "swiper/dist/css/swiper.min.css";
import { mapState } from "vuex";
export default {
  components: {
    swiper,
    swiperSlide,
  },
  mixins: [blogMixin],
  data() {
    return {
      swiperOptions: {
        slidesPerView: 4,
        spaceBetween: 20,
        pagination: {
          el: ".swiper-pagination",
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        breakpoints: {
          1600: {
            slidesPerView: 4,
            spaceBetween: 20,
          },
          1300: {
            slidesPerView: 4,
            spaceBetween: 20,
          },
          1240: {
            slidesPerView: 4,
            spaceBetween: 20,
          },
          900: {
            slidesPerView: 4,
            spaceBetween: 20,
          },
          820: {
            slidesPerView: 2.2,
            spaceBetween: 20,
          },
          768: {
            slidesPerView: 2.2,
            spaceBetween: 20,
          },
          640: {
            slidesPerView: 1,
            spaceBetween: 20,
          },
        },
      },
      blogs: [],
      categoryId: null,
      item: {},
    };
  },

  computed: {
    ...mapState("auth", { user: "user" }),
    ...mapState("respitecare", ["get_all_count", "allWithdrawalRequest"]),
    ...mapState("cms", {
      pageCategories: "pageCategories",
      filtertags: "filtertags",
      filters: "filters",
      categorywisepagesforevent: "categorywisepagesforevent",
      pages: "pages",
      categorywisepages: "categorywisepages",
    }),
  },

  methods: {
    readFullBlogs(item) {
      this.item = item;

      this.handleReadMore();
    },
    async init() {
      this.pageCategories.forEach((element) => {
        if (element.route.includes("blogs")) this.categoryId = element._id;
      });
      const campID = this.$route.params;
      let payload = {
        id: "61adf7f010718313e80bcc4b",
        selectedCampaigns: campID.id,
      };
      let { data } = await this.$store.dispatch(
        "cms/GetPagesbyCategoryForBlog",
        payload
      );
      // console.log("selected blogs :", data);
      this.blogs = data.data;
    },
    handleClick(URL) {
      let link = "";
      if (URL.includes("http")) {
        link = URL;
      } else {
        link = "https://" + URL;
      }
      return link;
    },
  },

  async mounted() {
    this.init();
    // await this.getAllCounts();
  },
};
</script>
